import { reduxForm } from 'redux-form';

import Form from 'components/forms/ContactForm';
import { focusFieldWithError } from 'utils/forms';

import validate from './validate';
import { FORM_ID } from './constants';

export default reduxForm({
  form: FORM_ID,
  onSubmitFail: focusFieldWithError(FORM_ID),
  validate,
})(Form);
